import { Typography } from "@mui/material";

const HeadLine = ({ text = null }) => {  
  const nameToDisplay = text || "";
  return (
    <Typography
      variant="h3"
      component="h1"
      gutterBottom
      style={{
        textAlign: "center",
      }}
      dir="rtl"
      padding="24px"
    >
      {nameToDisplay}
    </Typography>
  );
};

export default HeadLine;
